import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { getStorefrontConfig } from "./schema/get-storefront-config";

export const rpcDefinition = { getStorefrontConfig };

export type RedoCommerceCloudRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
